// extracted by mini-css-extract-plugin
module.exports = {"root":"inviteList_root__1t3n9"};